import { gql } from '@apollo/client';

export const GET_FAILED_TEST_RESULTS_FOR_FRY9C = gql`
query getFailedTestResultsForFRY9C($input: GetFailedTestResultsForFRY9CInput) {
  getFailedTestResultsForFRY9C(input: $input) {
    criteria {
      ruleId
      batchId
      isActive
      editChange
      editType
      editNumber
      effectiveStartDate
      effectiveEndDate
      mdrmList
      schedule
      targetItem
      ruleDescription
    }
    testResults{
      rowId
      testDate
      errorData
      errorColumns
      errorMessage
      errorDescription
      testPass
      testFail
      testError
      testRunStatus
    }
    pagination {
      totalCount
    }
  }
}
`;

export const GET_RULE_AUDIT_LOGS_FOR_FRY9C = gql`
query getAuditLogsForFRY9C($input: GetAuditLogsForFRY9CInput) {
  getAuditLogsForFRY9C(input: $input) {
    auditLogId
    eventId
    batchId
    ruleId
    commentId
    commentText
    userId
    user {
      firstName
      lastName
      initials
    }
    event {
      eventName
    }
    comment {
      commentText
    }
    createdAt
  }
}
`;

export const GET_COMMENTS_FOR_FRY9C = gql`
query getUserCommentsForFRY9C($input: GetUserCommentForFRY9CInput) {
  getUserCommentsForFRY9C(input: $input) {
    commentText
    commentId
    userId
    user{
    firstName
    lastName
    initials
  }
  FRY9CAuditLog{
    auditLogId
    eventId
    createdAt
    commentId
  }
  }
}
`;

export const GET_BATCH_TESTS_FOR_FRY9C = gql`
query getFRY9CBatchTests($input: GetFRY9CBatchTestsInput) {
  getFRY9CBatchTests(input: $input) {
    batchId
    totalRecords
    batchRunStatus
    batchStartTime
    ruleId
    period
    targetItem
    schedule
    mdrm
    isActive
    isRuleApplicable
    ruleDescription
    updatedAt
    fileName
    testError
    testFail
    testPass
    testRunStatus
    totalBatchTestRecords
    totalTestCases
    totalTestCompleted
    totalTestExecuted
    totalTestFailed
    totalTestInError
  }
}
`;

export const GET_QUARTER_FILTERED_BATCH_TESTS_FOR_FRY9C = gql`
query getFRY9CBatchTestsByQuarter($input: GetFRY9CBatchTestsByQuarterInput) {
  getFRY9CBatchTestsByQuarter(input: $input) {
    batchId
    ruleId
    period
    targetItem
    schedule
    mdrm
    isActive
    isRuleApplicable
    ruleDescription
    updatedAt
    totalRecords
    testPass
    testFail
    testError
    testRunStatus
    totalBatchTestRecords
    totalTestCases
    totalTestCompleted
    totalTestInError
    totalTestFailed
    fileName
    totalTestExecuted
    batchRunStatus
    batchStartTime
  }
}`;

export const GET_SUMMARY_QUARTERS_FOR_FRY9C = gql`
query getFRY9CSummaryQuarters($input: TenantIdInput) {
  getFRY9CSummaryQuarters(input: $input)
}`;

export const GET_DOWNLOADED_RESULT = gql`
query getFRY9CSummaryDetailsForDownload($input: GetFRY9CBatchTestsByQuarterInput) {
  getFRY9CSummaryDetailsForDownload(input: $input) {
    batchId
    ruleId
    period
    targetItem
    schedule
    mdrm
    isActive
    ruleDescription
    totalRecords
    testPass
    testFail
    testError
    testRunStatus
    totalBatchTestRecords
    totalTestCases
    totalTestCompleted
    totalTestInError
    totalTestFailed
    fileName
    totalTestExecuted
    batchRunStatus
    batchStartTime
  }
}`;

export const GET_LATEST_BATCH_FOR_FRY9C = gql`
query getCurrentStatusOfLatestBatchForFRY9C($input: TenantIdInput) {
  getCurrentStatusOfLatestBatchForFRY9C(input: $input) {
    batchRunStatus
    batchId
    batchEndTime
    batchStartTime
    totalRecords
    fileName
    totalTestCases
  }
}`;
